import React from 'react';

import {assert} from 'Asserts';
import {Sequence} from 'components/Sequence';
import {ASSEMBLY_TYPE} from 'constants/AssemblyConstants';
import {Cutsite as CutsiteType} from 'constants/MolbioConstants';
import Cutsite from 'molbio/enzymes/backbone/CutSite';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';

import {Assembly, AssemblySlotType} from './AssemblyModels';
import CurrentFragmentInfo from './CurrentFragmentInfo';
import {DigestFinalize, GibsonFinalize, GoldenGateFinalize} from './FinalizeComponents';
import AssemblyErrorsWarnings from './views/AssemblyErrorsWarnings';

interface Props {
  assembly: Assembly;
  activeSlot: AssemblySlotType;
  cutsites: Array<CutsiteType>;
  selection: {
    start: number;
    end: number;
    cutStart: Cutsite;
    cutEnd: Cutsite;
  };
  sequence: Sequence;
  updateParameters: () => void;
  createAssembly: () => void;
  deleteAssembly: () => void;
  errors: Array<string>;
  warnings: Array<string>;
}

interface State {
  showParameters: boolean;
}

class ActionZone extends React.Component<Props, State> {
  override state: State = {
    showParameters: false,
  };

  toggleParameters = (): void => {
    this.setState({showParameters: !this.state.showParameters});
  };

  override render(): JSX.Element {
    assert(this.props.assembly.method() != null, 'Expected assembly method to be set');
    const finalizeProps = {
      model: this.props.assembly,
      updateParameters: this.props.updateParameters,
      createAssembly: this.props.createAssembly,
      deleteAssembly: this.props.deleteAssembly,
      showParameters: this.state.showParameters,
      toggleParameters: this.toggleParameters,
    };
    return (
      <Row>
        <Col sm={5} className="js-fragment-info-wrapper u-small-spacing-bottom">
          {this.props.activeSlot != null ? (
            <CurrentFragmentInfo
              activeSlot={this.props.activeSlot}
              assembly={this.props.assembly}
              cutsites={this.props.cutsites}
              enzyme={this.props.assembly.enzyme()}
              selection={this.props.selection}
              sequence={this.props.sequence}
              toggleParameters={this.toggleParameters}
            />
          ) : (
            <div>
              <h4>Set Fragment</h4>
              <div className="faded u-small-spacing-top">Select an assembly fragment below.</div>
            </div>
          )}
        </Col>
        <Col sm={7} className="assembly-settings-col">
          <div className="pull-right">
            {this.props.assembly.method() === ASSEMBLY_TYPE.DIGEST && <DigestFinalize {...finalizeProps} />}
            {this.props.assembly.method() === ASSEMBLY_TYPE.GIBSON && <GibsonFinalize {...finalizeProps} />}
            {this.props.assembly.method() === ASSEMBLY_TYPE.GOLDEN_GATE && (
              <GoldenGateFinalize {...finalizeProps} />
            )}
          </div>
          <AssemblyErrorsWarnings
            title="Overall Assembly"
            errors={this.props.errors}
            warnings={this.props.warnings}
            method={this.props.assembly.method()!}
          />
        </Col>
      </Row>
    );
  }
}

export default ActionZone;
